export const ZINDEX_SPINNER = 9000;
export const ZINDEX_NOTIFICATION = 7000;
export const ZINDEX_APP_MESSAGE = 6000;
